const productTransitionData: Record<
  string,
  { launchDate: string; originalProductName: string }
> = {
  "mini-always-pan": {
    launchDate: "07/17/23",
    originalProductName: "Mini Always Pan",
  },
  "mini-perfect-pot": {
    launchDate: "07/17/23",
    originalProductName: "Mini Perfect Pot",
  },
};

export const getReviewedOnProductName = (
  productHandle: string,
  reviewCreatedAt: string
) => {
  if (productTransitionData[productHandle]) {
    const reviewDate = new Date(reviewCreatedAt).getTime();
    const transitionDate = new Date(
      productTransitionData[productHandle].launchDate
    ).getTime();

    if (reviewDate < transitionDate) {
      return productTransitionData[productHandle].originalProductName;
    }
  }
};
